<header class="famh-topbar" role="banner" (click)="$event.stopPropagation()">
  <div class="famh-shell">
    <a
      class="famh-brand"
      data-testid="marketing-header-brand"
      [routerLink]="brandLink()"
      (click)="trackBrandClick()"
    >
      FrontendAtlas
    </a>

    <nav class="famh-nav" aria-label="Primary">
      <button
        #menuTrigger
        type="button"
        class="famh-link famh-menu-trigger"
        data-testid="marketing-header-menu-trigger"
        [class.famh-link--active]="isMenuTriggerActive()"
        [attr.aria-expanded]="menuOpen()"
        aria-controls="marketing-prep-menu"
        (pointerenter)="preloadMenuIcons()"
        (focus)="preloadMenuIcons()"
        (click)="toggleMenu($event, 'desktop')"
      >
        Interview Prep <span class="famh-caret" aria-hidden="true">▾</span>
      </button>
      <a
        *ngFor="let link of primaryLinks"
        class="famh-link"
        data-testid="marketing-header-primary-link"
        [class.famh-link--active]="isPrimaryLinkActive(link)"
        [attr.aria-current]="isPrimaryLinkActive(link) ? 'page' : null"
        [routerLink]="link.route"
        [queryParams]="link.queryParams || null"
        (click)="trackPrimaryClick(link)"
      >
        {{ link.label }}
      </a>
    </nav>

    <div
      class="famh-actions"
      [attr.aria-busy]="auth.authUiState() === 'pending' ? 'true' : null"
    >
      <ng-container [ngSwitch]="auth.authUiState()">
        <div
          *ngSwitchCase="'pending'"
          class="famh-auth-placeholder famh-auth-placeholder--desktop"
          data-testid="marketing-header-auth-pending"
          aria-hidden="true"
        >
          <span class="famh-auth-placeholder__item"></span>
          <span class="famh-auth-placeholder__item"></span>
          <span class="famh-auth-placeholder__item famh-auth-placeholder__item--cta"></span>
        </div>

        <ng-container *ngSwitchCase="'signed_out'">
          <a
            *ngFor="let link of guestUtilityLinks"
            class="famh-link"
            data-testid="marketing-header-utility-link"
            routerLinkActive="famh-link--active"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="link.route"
            [queryParams]="link.queryParams || null"
            (click)="trackUtilityClick(link)"
          >
            {{ link.label }}
          </a>
        </ng-container>

        <ng-container *ngSwitchCase="'authenticated'">
          <a
            *ngFor="let link of loggedInUtilityLinks"
            class="famh-link"
            data-testid="marketing-header-utility-link"
            routerLinkActive="famh-link--active"
            [routerLinkActiveOptions]="{ exact: true }"
            [routerLink]="link.route"
            (click)="trackUtilityClick(link)"
          >
            {{ link.label }}
          </a>
        </ng-container>
      </ng-container>

      <a
        *ngIf="isAuthUiResolved()"
        class="famh-cta"
        data-testid="marketing-header-cta"
        [routerLink]="ctaLink()"
        [queryParams]="ctaQueryParams()"
        (click)="trackCtaClick()"
      >
        {{ ctaLabel() }}
      </a>
    </div>

    <button
      #mobileMenuTrigger
      type="button"
      class="famh-menu-toggle"
      data-testid="marketing-header-mobile-menu-button"
      [attr.aria-expanded]="menuOpen()"
      aria-controls="marketing-prep-menu"
      aria-label="Open navigation menu"
      (pointerenter)="preloadMenuIcons()"
      (focus)="preloadMenuIcons()"
      (click)="toggleMenu($event, 'mobile')"
    >
      <span>Menu</span>
      <span class="famh-menu-toggle__icon" aria-hidden="true">{{ menuOpen() ? '×' : '☰' }}</span>
    </button>
  </div>

  <div *ngIf="menuOpen()" class="famh-backdrop" (click)="closeMenu()"></div>
  <app-prep-menu-panel
    panelId="marketing-prep-menu"
    testIdPrefix="marketing-header-menu"
    [open]="menuOpen()"
    [currentPath]="currentPath()"
    [anchorX]="menuAnchorX()"
    [(activeSection)]="menuSection"
    (itemSelected)="onMenuItemSelected($event)"
  >
    <ng-container ngProjectAs="[prepMenuTop]">
      <div *ngIf="menuOpen()" class="famh-mobile-panel" data-testid="marketing-header-mobile-menu">
        <div class="famh-mobile-section">
          <a
            *ngFor="let link of primaryLinks"
            class="famh-mobile-link"
            data-testid="marketing-header-mobile-link"
            [class.famh-mobile-link--active]="isPrimaryLinkActive(link)"
            [attr.aria-current]="isPrimaryLinkActive(link) ? 'page' : null"
            [routerLink]="link.route"
            [queryParams]="link.queryParams || null"
            (click)="trackPrimaryClick(link, 'mobile_menu')"
          >
            {{ link.label }}
          </a>
        </div>

        <div class="famh-mobile-section">
          <div class="famh-mobile-section__title">Account</div>
          <div
            class="famh-mobile-auth"
            [attr.aria-busy]="auth.authUiState() === 'pending' ? 'true' : null"
          >
            <ng-container [ngSwitch]="auth.authUiState()">
              <div
                *ngSwitchCase="'pending'"
                class="famh-auth-placeholder famh-auth-placeholder--mobile"
                data-testid="marketing-header-mobile-auth-pending"
                aria-hidden="true"
              >
                <span class="famh-auth-placeholder__item"></span>
                <span class="famh-auth-placeholder__item"></span>
                <span class="famh-auth-placeholder__item famh-auth-placeholder__item--cta"></span>
              </div>

              <ng-container *ngSwitchCase="'signed_out'">
                <a
                  *ngFor="let link of guestUtilityLinks"
                  class="famh-mobile-link"
                  data-testid="marketing-header-mobile-utility-link"
                  routerLinkActive="famh-mobile-link--active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="link.route"
                  [queryParams]="link.queryParams || null"
                  (click)="trackUtilityClick(link, 'mobile_menu')"
                >
                  {{ link.label }}
                </a>
              </ng-container>

              <ng-container *ngSwitchCase="'authenticated'">
                <a
                  *ngFor="let link of loggedInUtilityLinks"
                  class="famh-mobile-link"
                  data-testid="marketing-header-mobile-utility-link"
                  routerLinkActive="famh-mobile-link--active"
                  [routerLinkActiveOptions]="{ exact: true }"
                  [routerLink]="link.route"
                  (click)="trackUtilityClick(link, 'mobile_menu')"
                >
                  {{ link.label }}
                </a>
              </ng-container>
            </ng-container>

            <a
              *ngIf="isAuthUiResolved()"
              class="famh-mobile-cta"
              data-testid="marketing-header-mobile-cta"
              [routerLink]="ctaLink()"
              [queryParams]="ctaQueryParams()"
              (click)="trackCtaClick('mobile_menu')"
            >
              {{ ctaLabel() }}
            </a>
          </div>
        </div>
      </div>
    </ng-container>
  </app-prep-menu-panel>
</header>
